import { InjectionToken } from "@angular/core";
import { DataBusFacade, EventBusFacade } from "remote-module-context";

import { DataBus } from "./data-bus";
import { EventBus } from "./event-bus";

export const T_EVENT_BUS = new InjectionToken<EventBus>("eventBus");
export const T_DATA_BUS = new InjectionToken<DataBus>("dataBus");
export const T_SHELL_EVENT_BUS_FACADE = new InjectionToken<EventBusFacade>("shellEventBusFacade");
export const T_SHELL_DATA_BUS_FACADE = new InjectionToken<DataBusFacade>("shellDataBusFacade");
export const T_REMOTE_MODULE_LOADER = new InjectionToken<(identifier: string) => void>("loadRemoteModule");
